import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import InputField from '../../components/forms/InputField';
import logo from '../../assets/images/logo.png'; // Update the path to your logo
import resetImage from '../../assets/images/resetPassword.webp'; // Update the path to your image
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { errorToast, successToast } from '../../components/toast';
import { resetPasswordAction } from '../../redux/actions/authAction';
import LoaderModal from '../../components/modals/loaderModal';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    let { token } = useParams();

    const initialValues = {
        password: '',
        confirmPassword: '',
    };

    const validationSchema = Yup.object({
        password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('New Password is required'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('Confirm Password is required'),
    });

    const handleSubmit = (values) => {
        const dispatchingValues = {
            resetToken: token,
            password: values.confirmPassword,
        }
        dispatch(resetPasswordAction(dispatchingValues, onSuccess, onError))
        setLoading(true)
    };

    const onSuccess = (data) => {
        successToast(data.data.message);
        navigate('/');
        setLoading(false);
    }

    const onError = (data) => {
        errorToast(data.data.message);
        setLoading(false);
    }

    return (
        <div className="flex h-screen bg-gray-100">
            {/* Left Section with Image */}
            <div className="w-1/2 bg-primary flex items-center justify-center">
                <img src={resetImage} alt="Reset Password" className="max-w-full h-auto" />
            </div>

            {/* Right Section with Form */}
            <div className="w-1/2 flex items-center justify-center">
                <div className="bg-white shadow-lg rounded-lg p-8 w-4/5 max-w-lg">
                    {/* Logo */}
                    <div className="text-center mb-6">
                        <img src={logo} alt="Logo" className="w-20 mx-auto mb-2" />
                        <h2 className="text-2xl font-heading font-bold text-primary">Reset Password</h2>
                        <p className="text-gray-500 mt-2">
                            Set a new password to regain access to your account.
                        </p>
                    </div>

                    {/* Form */}
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        <Form>
                            <InputField
                                label="New Password"
                                name="password"
                                type="password"
                                placeholder="Enter your new password"
                            />
                            <InputField
                                label="Confirm Password"
                                name="confirmPassword"
                                type="password"
                                placeholder="Confirm your new password"
                            />
                            <button
                                type="submit"
                                className="w-full bg-primary text-white py-2 px-4 rounded-lg hover:bg-primary-hover mt-4"
                            >
                                Reset Password
                            </button>
                        </Form>
                    </Formik>
                </div>
            </div>
            {loading && <LoaderModal />}
        </div>
    );
};

export default ResetPasswordPage;
